import { Flame } from 'lucide-react';
import { cn } from '../../lib/utils';
import { tierAccent } from '../../constants/supporterTiers';

// Supporter tier badge — "The Forge". Renders a flame + tier name tinted by the
// tier accent; tiers flagged `glow` get an animated heat halo. Used large on
// the profile and small on roster/search cards.
//
// size: 'sm' (cards) | 'lg' (profile)
const TierBadge = ({ tier, size = 'sm', className }) => {
  if (!tier) return null;
  const accent = tierAccent(tier.accent);
  // The tier's own `glow` flag (admin-editable) wins; fall back to the accent's
  // default for tiers that predate the flag.
  const glow = tier.glow !== undefined ? tier.glow : accent.glow;
  const lg = size === 'lg';

  return (
    <span
      className={cn(
        'inline-flex items-center gap-1.5 rounded-md border font-mono uppercase tracking-[0.2em]',
        accent.text,
        accent.border,
        lg ? 'px-3 py-1 text-[11px]' : 'px-1.5 py-0.5 text-[9px]',
        className
      )}
      title={`Supporter tier · ${tier.name}`}
    >
      <Flame className={cn(lg ? 'h-3.5 w-3.5' : 'h-2.5 w-2.5', glow && 'animate-tier-glow')} />
      {tier.name}
    </span>
  );
};

export default TierBadge;
